import Raven from 'raven-js';
import { RAVEN_CLIENT_KEY, RAVEN_OPTIONS } from 'CommonConfig';

const env = { production: process.env.NODE_ENV === 'production' };

if (env.production) {
  Raven.config(RAVEN_CLIENT_KEY, RAVEN_OPTIONS).install();
}



// WEBPACK FOOTER //
// ./ridi/ridi.sentry.js